'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _checkout = require('./remote/checkout');

exports.default = {
    fetchInvoice: _checkout.Checkout.fetchInvoice
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/checkout.js
// module id = sSv9
// module chunks = 60